import { SimpleSelectMenu } from '@cko/primitives';
import React from 'react';
const zoomValues = [
    { label: '300%', value: 300 },
    { label: '275%', value: 275 },
    { label: '250%', value: 250 },
    { label: '225%', value: 225 },
    { label: '200%', value: 200 },
    { label: '175%', value: 175 },
    { label: '150%', value: 150 },
    { label: '125%', value: 125 },
    { label: '100%', value: 100 },
    { label: '75%', value: 75 },
    { label: '50%', value: 50 },
    { label: '25%', value: 25 },
];
const ZoomSelector = (props) => {
    const { isDisabled, onZoomChange, zoom } = props;
    const selectedItem = zoomValues.find((item) => item.value === zoom);
    return (React.createElement(SimpleSelectMenu, { disabled: isDisabled, onChange: (selectedZoom) => onZoomChange(selectedZoom.value), options: zoomValues, selectedItem: selectedItem }));
};
export default ZoomSelector;
